export default __webpack_public_path__ + "static/SRF Carasweet 5S7705 - Product Specifications & Technical Data-aa3480b0a002a03df63a0cf0a3aa7a41.pdf";